import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router=new  Router({
    routes:[
        {
            path:'/',
            redirect:'/Aboutus'
        },{
            name:'Login',
            path:'/login',
            component:()=>import('../components/Login.vue')
        },
        {
            name:'Yjy',
            path:'/yjy',
            component:()=>import('../components/yjy.vue')
        },
        {
            name:'Home',
            path:'/Home',
            component:()=>import('../components/Home.vue'),
            children:[
                {
                    name:'Aboutus',
                    path:'/Aboutus',
                    component:()=>import('../components/Aboutus.vue')
                },{
                    name:'Contactus',
                    path:'/Contactus',
                    component:()=>import('../components/Contactus.vue')
                },{
                    name:'Info',
                    path:'/Info',
                    component:()=>import('../components/Info.vue')
                },{
                    name:'Products',
                    path:'/Products',
                    component:()=>import('../components/Products.vue')
                },
                {
                    name:'Yjy',
                    path:'/yjy',
                    component:()=>import('../components/yjy.vue')
                },
              {
                name:'productDetails',
                    path:'/productDetails',
                    component:()=>import('../components/ProductDetails.vue')
                }
            ]
         },

    ]
})
router.afterEach((to,from,next)=>{

    window.document.title="中安星瑞航空科技有限公司"

})
export default router
